import { string, shape } from 'prop-types';

export const IconType = shape({
    url: string.isRequired
});

export interface Icon {
    url: string;
}
